export const environment = {
  production: false,
  development: false,
  local: false,
  homolog: true,
  apiKey: 'homolKey',
  uiUrl: 'https://homol.grupolpj-onepage.com/',
  apiUrl: 'https://api.homol.grupolpj-onepage.com/',
  bundleUrl: 'https://mf-bpmn.homol.grupolpj-onepage.com/bundle.js',
  formacaoPrecoBundleUrl: 'https://precificacao.homol.grupolpj-onepage/remoteEntry.js',
  tableUrl: 'https://autofp.homol.grupolpj-onepage.com/table.js',
  spreadsheetsUrl: 'https://autofp.homol.grupolpj-onepage.com/spreadsheets.js',
  mainUrl: 'https://autofp.homol.grupolpj-onepage.com/main.js',
  parametersUrl: 'https://autofp.homol.grupolpj-onepage.com/parameters.js',
  tls_cert: 'tls-cert-qas.pem',
  tls_key: 'tls-key-qas.pem'
}
